import React from 'react';

export default class Page7 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">

                                <div className="ilead-rgt ">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <table className="ilead_v_sport people_active tablesrink"
                                                   border="0" cellPadding="0" cellSpacing="0" width="100%">
                                                <tbody>
                                                <tr>
                                                    <th className="green_curve green_curve1" align="left"
                                                        valign="center" width="100%">My Reflections
                                                    </th>

                                                </tr>
                                                <tr>
                                                    <td className="lightgreen text-box" align="left"
                                                        valign="top" width="20%">
                                                        <textarea className="textareaborder width-sept"
                                                                  name="textarea"
                                                                  rows="20"
                                                                  value={this.props.pageData?.MyReflections?.textarea}
                                                                  onChange={this.props.handleChangePageData('MyReflections')}/>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>


                                            <p>Through this exercise you should have identified some of the
                                                key factors in helping you to make
                                                timely decisions. It is often useful to reflect on past
                                                experience in order to learn from mistakes
                                                and consider what we could do differently and more
                                                successfully in the future and what we
                                                should keep on doing which has worked for us in the
                                                past.</p>
                                            <div className="circle_title"><span className="heading"><img
                                                src={require('@images/greendot.jpg')}
                                                className="heading_image"/></span><span className="heading">
                    HINTS AND TIPS FOR TIMELY DECISIONS
                    </span></div>
                                            <ul className="greenbullet-list paraspace sept">
                                                <li><p>Make sure you have as much available or accessible
                                                    information as possible.</p></li>
                                                <li><p>Do you need more information – if so, what? Where
                                                    will you find it?</p></li>
                                                <li><p>Have you consulted relevant stakeholders about who
                                                    needs the decision,
                                                    who’s involved and what the budget is, if
                                                    appropriate?</p></li>
                                                <li><p>Agree at the outset when the decision is needed
                                                    by.</p></li>
                                                <li><p>Keep to the time limit, but try to make your plan
                                                    flexible to allow for unforeseen
                                                    circumstances.</p></li>
                                                <li><p>Allocate time for collecting information and
                                                    consulting people before the decision
                                                    needs to be made.</p></li>
                                                <li><p>If others are working with you, communicate your
                                                    plans to everyone involved,
                                                    so that each knows what needs to be done, and when.</p>
                                                </li>
                                                <li><p>Brainstorm potential obstacles which could delay or
                                                    compromise your decision.</p></li>
                                                <li><p>Think about possible objections from others and how
                                                    you would address them.</p></li>
                                                <li><p>Think about the implications of making your decision
                                                    too late or too early.</p></li>
                                                <li><p>Prioritise tasks to help ensure a timely
                                                    decision.</p></li>
                                                <li><p>If you are making a decision in a team, delegate
                                                    tasks to ensure everyone is
                                                    involved and all the information is collected in a
                                                    timely way.</p></li>


                                            </ul>


                                            <div className="circle_title"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>NEXT STEPS
                                            </div>
                                            <p>Now that you have considered the information in this tool and
                                                tried out some of the practical
                                                exercises, here are a number of next steps to embed the
                                                learning:</p>
                                            <div className="border_subtitle">Look for opportunities to
                                                practise
                                            </div>
                                            <p>Think about opportunities in your current work, or elsewhere
                                                to practise making timely decisions.
                                                When do you need to make them by, to suit you and
                                                others?</p>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page6')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div onClick={this.props.savePageData('Page8')}
                                                     className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}